import { render, staticRenderFns } from "./OpenLayout.vue?vue&type=template&id=5fcc781d"
import script from "./OpenLayout.vue?vue&type=script&lang=js"
export * from "./OpenLayout.vue?vue&type=script&lang=js"
import style0 from "./OpenLayout.vue?vue&type=style&index=0&id=5fcc781d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports